import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const WorkStep = () => {
    const [stepwork, setWork] = useState([]);


    const [page, setPage] = useState([]);
    const [selectedSlug, setSelectedSlug] = useState(""); // State to store pageSlug

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page`)
            .then((res) => res.json())
            .then((info) => setPage(info));
    }, []);

    const handlePageChange = (e) => {
        const selectedPage = page.find((p) => p.pageName === e.target.value);
        setSelectedSlug(selectedPage ? selectedPage.pageSlug : ""); // Store selectedSlug
    };

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/worksec`)
            .then((res) => res.json())
            .then((info) => setWork(info));
    }, []);

    const handleWorkSection = (event) => {
        event.preventDefault();
        const pageName = event.target.pageName.value;
        const stepNumber = event.target.stepNumber.value;
        const stepTitle = event.target.stepTitle.value;
        const stepDetails = event.target.stepDetails.value;

        const workSection = { stepNumber, stepTitle, stepDetails, pageName, pageSlug: selectedSlug, };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/add-worksec`;
        fetch(url, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(workSection),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Work Step is Updated');
            });
    };

    return (
        <>
            <HeaderBottom />
            <div>
                <section className="services-area ">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-12">
                                <h3 className="text-center mt-5">Add Work Step Section</h3>

                                <table className="table table-bordered">
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <th>Sl No</th>
                                            <th>Page Name</th>
                                            <th>Heading About</th>
                                            <th>Edit/Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stepwork.map((page, index) => (
                                            <tr key={page._id}>
                                                <td>{index + 1}</td>
                                                <td>{page.pageName}</td>
                                                <td>{page.stepTitle}</td>
                                                <td>
                                                    <Link to={`/edit-work/${page._id}`} className="btn btn-lg btn-warning">
                                                        <i className="fas fa-edit"></i>  Edit Now
                                                    </Link>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>


                                <form className="contact-form" onSubmit={handleWorkSection}>

                                    <div className="text-black">
                                        <select
                                            name="pageName"
                                            className="form-select w-100 px-3 py-2 mb-3 border border-gray-300 rounded-lg "
                                            required
                                            style={{ color: 'black' }}
                                            onChange={handlePageChange}
                                        >
                                            <option value="" disabled selected>
                                                Select Page
                                            </option>
                                            {page.map((p) => (
                                                <option key={p._id} value={p.pageName}>
                                                    {p.pageName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>




                                    <div className="row">

                                        <div className="col-lg-12 col-md-12 ">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control "
                                                    value={selectedSlug} // Set value from state
                                                    readOnly
                                                    placeholder="Page Slug"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control " name="stepNumber" placeholder="Step Number" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control " name="stepTitle" placeholder="Step Title" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control " name="stepDetails" placeholder="Step Details" required />
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <button className="button-professional mt-3">Add Work Step</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default WorkStep;
